import RepositoryFactory from "../../admin/apis/index";
const category = RepositoryFactory.EcomCategory;

export default {
  addCategory({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await category.addCategory(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  editCategory({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await category.editCategory(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getCategory({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await category.getCategory();

        commit("SET_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getDetailedCategory({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await category.getDetailedCategory();

        commit("SET_DETAILED_CATEGORY", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getDetailedCategoryAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await category.getDetailedCategoryAll(payload);

        commit("SET_DETAILED_CATEGORYAll", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
